export enum QuestCategory {
  Creator = 'Creator',
  Explorer = 'Explorer',
  SkillBuilder = 'Skill-Builder',
  TeamUp = 'Team-Up',
}

export interface Quest {
  id: number;
  category: QuestCategory;
  title: string;
  description: string;
  details: string;
  repeatDescription?: string;
  repeatDetails?: string;
  questlineId?: string;
  isQuestlineStart?: boolean;
  prerequisiteQuestId?: number;
  youtubeId?: string;
}